import React, { useEffect, useState } from "react";

import { Eyebrow, Title } from "../components/CommonComponents";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import awardGallery1 from "../assets/img/awards/gallery/ISBMU-awards14.webp";
import awardGallery2 from "../assets/img/awards/gallery/ISBMU-awards1.webp";
import awardGallery3 from "../assets/img/awards/gallery/ISBMU-awards2.webp";
import awardGallery4 from "../assets/img/awards/gallery/ISBMU-awards4.webp";
import awardGallery5 from "../assets/img/awards/gallery/ISBMU-awards5.webp";
import awardGallery6 from "../assets/img/awards/gallery/ISBMU-awards6.webp";
import awardGallery7 from "../assets/img/awards/gallery/ISBMU-awards7.webp";
import awardGallery8 from "../assets/img/awards/gallery/ISBMU-awards8.webp";
import awardGallery9 from "../assets/img/awards/gallery/ISBMU-awards9.webp";
import awardGallery10 from "../assets/img/awards/gallery/ISBMU-awards10.webp";
import awardGallery11 from "../assets/img/awards/gallery/ISBMU-awards11.webp";
import awardGallery12 from "../assets/img/awards/gallery/ISBMU-awards12.webp";
import awardGallery13 from "../assets/img/awards/gallery/ISBMU-awards13.webp";
import awardGallery14 from "../assets/img/awards/gallery/ISBMU-awards15.jpeg";

import award1 from "../assets/img/awards/isbm-university-best-upcoming-private-university-award-2017.png";
import award2 from "../assets/img/awards/isbm-university-digital-initiatives-award-2019.webp";
import award3 from "../assets/img/awards/isbm-university-assocham-edushine-excellence-award-2019.png";
import award4 from "../assets/img/awards/isbm-university-best-education-system-university-india-award-2019.png";
import award5 from "../assets/img/awards/isbm-university-higher-education-excellence-certificate-2019.webp";
import award6 from "../assets/img/awards/isbm-university-excellence-it-education-west-india-award-2019.png";
import award7 from "../assets/img/awards/isbm-university-all-india-inter-university-woodball-winner-2023.png";
import award8 from "../assets/img/awards/isbm-university-best-emerging-private-university-chhattisgarh-2017.webp";
import award9 from "../assets/img/awards/isbm-university-best-emerging-university-award-2011.png";
import award10 from "../assets/img/awards/isbm-university-best-university-central-india-placement-2023.png";
import award11 from "../assets/img/awards/isbm-university-world-education-summit-xcellence-award-2019.png";
import award12 from "../assets/img/awards/isbm-university-best-private-university-chhattisgarh-2022.png";
import award13 from "../assets/img/awards/isbm-university-best-private-university-central-india-placement-2023.png";
import award14 from "../assets/img/awards/anand-mahalwar-outstanding-academic-excellence-award-2023.webp";
import award15 from "../assets/img/awards/anand-mahalwar-education-excellence-award-2024.webp";
import award16 from "../assets/img/awards/isbm-university-naya-bharat-utsav-participation-2024.png";
import award17 from "../assets/img/awards/isbm-university-most-innovative-university-award-2018.png";
import award18 from "../assets/img/awards/isbm-university-best-pharmaceutical-studies-award-2022.png";
import award19 from "../assets/img/awards/isbm-university-best-private-university-india-award-2024.png";
import award20 from "../assets/img/awards/isbm-university-education-excellence-award-2024.png";
import award21 from "../assets/img/awards/isbm-university-leading-private-university-central-india-award-2026.png";

const awards = [
    {
        number: "21",
        year: "2026",
        category: "University Excellence Award",
        title: "Leading Private University of the Year (Central India)",
        organisation: "WBR Corp",
        description:
            "ISBM University was recognised as the Leading Private University of the Year (Central India) at the India @2047 Leadership, Innovation & Global Power Summit & Awards 2026. The Certificate of Excellence was presented by WBR Corp on 20th August 2026 at IIT Delhi.",
        image: award21
    },
    {
        number: "20",
        year: "2024",
        category: "Education Excellence Award",
        title: "Education Excellence Award 2024",
        organisation: "LEO1",
        description:
            "ISBM University, Chhattisgarh was recognised with the Education Excellence Award 2024, acknowledging the university's contribution and commitment to excellence in higher education.",
        image: award20
    },
    {
        number: "19",
        year: "2024",
        category: "University Excellence Award",
        title: "Best Private University in India",
        organisation: "Topnotch Foundation",
        description:
            "ISBM University was recognised as the Best Private University in India at the Dr. A.P.J. Abdul Kalam Inspiration Awards 2024, presented by Topnotch Foundation on 29th June 2024 at Bharat Mandapam, New Delhi.",
        image: award19
    },
    {
        number: "16",
        year: "2024",
        category: "Participation Awards",
        title: "Naya Bharat Utsav 2024 – Vikas Pradarshini Participation",
        organisation: "Naya Bharat Utsav",
        description:
            "ISBM University received recognition for its participation in the Vikas Pradarshini organised as part of Naya Bharat Utsav 2024.",
        image: award16
    },
    {
        number: "15",
        year: "2024",
        category: "Education Excellence Award",
        title: "Education Excellence Award 2024",
        organisation: "COER University, Roorkee",
        description:
            "Prof. (Dr.) Anand Mahalwar received the Education Excellence Award 2024 at COER University, Roorkee on 10th February 2024, recognising his achievements, contributions to education and participation as a Power Speaker at Bharat Gyan Samagam 2024.",
        image: award15
    },
    {
        number: "14",
        year: "2023",
        category: "Academic Excellence Award",
        title: "Outstanding Academic Excellence Award",
        organisation: "Apollo College of Pharmacy, Durg",
        description:
            "Prof. Anand Mahalwar received the Outstanding Academic Excellence Award from Apollo College of Pharmacy, Durg in recognition of his exceptional dedication, contribution to teaching and commitment to academic excellence.",
        image: award14
    },
    {
        number: "13",
        year: "2023",
        category: "Placement Excellence Award",
        title: "Best Private University in Central India for Placement",
        organisation: "Centre for Education Growth and Research (CEGR)",
        description:
            "ISBM University was recognised as the Best Private University in Central India for Placement 2023 for its outstanding contribution to education, skill development and research at the 20th Rashtriya Shiksha Gaurav Puraskar Ceremony, held on 18th April 2023 in New Delhi.",
        image: award13
    },
    {
        number: "10",
        year: "2023",
        category: "Placement Excellence Award",
        title: "Best University in Central India for Placement",
        organisation: "Centre for Education Growth and Research (CEGR)",
        description:
            "ISBM University, Raipur was recognised as the Best University in Central India for Placement 2023 for its outstanding contribution to education, skill development and research at the 21st Rashtriya Shiksha Gaurav Puraskar Ceremony, held on 27th September 2023 in New Delhi.",
        image: award10
    },
    {
        number: "07",
        year: "2023",
        category: "Sports Achievement",
        title: "Winner – Fairway (Men) Woodball Tournament",
        organisation: "All India Inter University Woodball Tournament",
        description:
            "ISBM University achieved the Winner title in the Fairway (Men) category at the All India Inter University Woodball Tournament, held from 17th to 27th February 2023.",
        image: award7
    },
    {
        number: "18",
        year: "2022",
        category: "Pharmaceutical Education Excellence",
        title: "Best University for Pharmaceutical Studies",
        organisation: "Indo-UK Global Business & Corporate Awards",
        description:
            "ISBM University received the Certificate of Excellence for Best University for Pharmaceutical Studies at the Indo-UK Global Business & Corporate Awards 2022, held on 4th November 2022 at the House of Lords in London, United Kingdom.",
        image: award18
    },
    {
        number: "12",
        year: "2022",
        category: "University Excellence Award",
        title: "Best Private University in Chhattisgarh",
        organisation: "Centre for Education Growth and Research (CEGR)",
        description:
            "ISBM University was recognised as the Best Private University in Chhattisgarh 2022 by the Centre for Education Growth and Research for its outstanding contribution to education, skill development and research at the 19th Rashtriya Shiksha Gaurav Puraskar Ceremony, held on 22nd December 2022 in Bengaluru.",
        image: award12
    },
    {
        number: "11",
        year: "2019",
        category: "Education Excellence Award",
        title: "World Education Summit & Xcellence Awards",
        organisation: "ASSOCHAM India",
        description:
            "ISBM University was honoured at the World Education Summit & Xcellence Awards 2019, held on 19th November 2019 in New Delhi, recognising excellence and contribution in the field of higher education.",
        image: award11
    },
    {
        number: "06",
        year: "2019",
        category: "IT Education Excellence",
        title: "Excellence in IT Education in West India",
        organisation: "ET NOW",
        description:
            "ISBM University was recognised for Excellence in IT Education in West India at the India Leadership Awards 2019, celebrating the university's contribution to technology and IT education.",
        image: award6
    },
    {
        number: "05",
        year: "2019",
        category: "Higher Education Excellence",
        title: "Certificate of Excellence in Higher Education",
        organisation: "Elets Technomedia",
        description:
            "ISBM University, Chhattisgarh received a Certificate of Excellence for its exemplary contribution to the field of higher education at the 11th Higher Education & Human Resource Conclave, held on 4th May 2019 in Pune, Maharashtra.",
        image: award5
    },
    {
        number: "04",
        year: "2019",
        category: "Education System Excellence",
        title: "Best Education System University in India",
        organisation: "ASSOCHAM India",
        description:
            "ISBM University was recognised as the Best Education System University in India at the World Education Summit & Awards 2019, held on 19th November 2019 at Le Méridien, New Delhi.",
        image: award4
    },
    {
        number: "03",
        year: "2019",
        category: "Education Excellence Award",
        title: "EduShine Excellence Award",
        organisation: "ASSOCHAM India",
        description:
            "ISBM University was honoured at the 12th ASSOCHAM National Education Summit under the EduShine Excellence Awards 2019, recognising its contribution and initiatives in higher education.",
        image: award3
    },
    {
        number: "02",
        year: "2019",
        category: "Digital Initiatives in Higher Education",
        title: "Emerging University Promoting Government Digital Initiatives",
        organisation: "ASSOCHAM India",
        description:
            "ISBM University, Chhattisgarh was recognised as an Emerging University Promoting Government Digital Initiatives at the 12th ASSOCHAM National Education Summit and EduShine Excellence Awards 2019, held on 21st February 2019 in New Delhi.",
        image: award2
    },
    {
        number: "17",
        year: "2018",
        category: "Innovation in Education Award",
        title: "Most Innovative University",
        organisation: "News18 Madhya Pradesh Chhattisgarh",
        description:
            "ISBM University was recognised as the Most Innovative University at the Sushiksha Chhattisgarh awards organised by News18 Madhya Pradesh Chhattisgarh on 20th June 2018 in Raipur.",
        image: award17
    },
    {
        number: "08",
        year: "2017",
        category: "Emerging University Award",
        title: "Best Emerging Private University in Chhattisgarh",
        organisation: "Sanibal News",
        description:
            "ISBM University was recognised as the Best Emerging Private University in Chhattisgarh at the Udaan Gram Chhattisgarh 2017 awards, acknowledging the university's growth and contribution to higher education.",
        image: award8
    },
    {
        number: "01",
        year: "2017",
        category: "Education Excellence Award",
        title: "Best Upcoming Private University",
        organisation: "ASSOCHAM India",
        description:
            "ISBM University, Chhattisgarh was recognised as the Best Upcoming Private University at the ASSOCHAM National Education Excellence Awards 2017. The award was presented by Shri Prakash Javadekar, Hon'ble Union Minister of HRD, on 23rd February 2017.",
        image: award1
    },
    {
        number: "09",
        year: "2011",
        category: "Emerging University Award",
        title: "Best Emerging University",
        organisation: "Better India Education Awards",
        description:
            "ISBM University received the Best Emerging University recognition at the Better India Education Awards 2011, held on 25th June 2011 in New Delhi, recognising its growing contribution to education.",
        image: award9
    }
];

const galleryImages = [
    {
        image: awardGallery1,
        title: "Excellence Award Ceremony",
        category: "Recognition",
        alt: "ISBM University receiving an Excellence Award"
    },
    {
        image: awardGallery2,
        title: "University Recognition",
        category: "Awards",
        alt: "ISBM University award presentation ceremony"
    },
    {
        image: awardGallery3,
        title: "Excellence in Education",
        category: "Recognition",
        alt: "ISBM University recognised for excellence in education"
    },
    {
        image: awardGallery4,
        title: "Academic Recognition",
        category: "Awards",
        alt: "Award certificate being presented at an ISBM University event"
    },
    {
        image: awardGallery5,
        title: "Janmat Chhattisgarh Recognition",
        category: "Recognition",
        alt: "ISBM University recognition at Janmat Chhattisgarh"
    },
    {
        image: awardGallery6,
        title: "ASSOCHAM Education Summit",
        category: "National Recognition",
        alt: "ISBM University recognition at ASSOCHAM National Education Summit"
    },
    {
        image: awardGallery7,
        title: "Education Excellence Award",
        category: "Awards",
        alt: "ISBM University receiving an education excellence award"
    },
    {
        image: awardGallery8,
        title: "National Achievement",
        category: "Recognition",
        alt: "ISBM University award presentation ceremony"
    },
    {
        image: awardGallery9,
        title: "National Education Excellence Awards",
        category: "ASSOCHAM",
        alt: "ISBM University at the National Education Excellence Awards"
    },
    {
        image: awardGallery10,
        title: "Excellence in Higher Education",
        category: "Recognition",
        alt: "ISBM University receiving recognition for excellence in higher education"
    },
    {
        image: awardGallery11,
        title: "Udaan Chhattisgarh",
        category: "University Recognition",
        alt: "ISBM University recognition at Udaan Chhattisgarh"
    },
    {
        image: awardGallery12,
        title: "Indo-UK Global Recognition",
        category: "International Recognition",
        alt: "ISBM University Indo-UK Global Business Awards recognition"
    },
    {
        image: awardGallery13,
        title: "Eminence Awards",
        category: "Academic Recognition",
        alt: "ISBM University recognition at the Eminence Awards"
    },
    {
        image: awardGallery14,
        title: "Inter University Woodball Achievement",
        category: "Sports Achievement",
        alt: "ISBM University Woodball team with championship trophy"
    }
];
export default function Awards() {
    const featuredAwards = awards.slice(0, 3);
    const topAwards = awards.slice(0, 2);

    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        if (!selectedImage) return;

        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setSelectedImage(null);
            }
        };

        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", handleEscape);

        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", handleEscape);
        };
    }, [selectedImage]);

    const awardsTimeline = Object.values(
        awards.reduce((acc, award) => {
            if (!acc[award.year]) {
                acc[award.year] = {
                    year: award.year,
                    count: 0,
                    categories: [],
                };
            }

            acc[award.year].count += 1;

            if (!acc[award.year].categories.includes(award.category)) {
                acc[award.year].categories.push(award.category);
            }

            return acc;
        }, {})
    ).sort((a, b) => Number(a.year) - Number(b.year));

    return (
        <>
            <MetaInfo param="" id="about" />

            <Header school="common" />

            <main className="overflow-hidden bg-white text-[#132337]">
                {/* HERO */}
                <section className="relative isolate min-h-[760px] overflow-hidden bg-[#071A2F] pt-[100px] text-white">
                    <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_82%_18%,rgba(213,173,87,0.18),transparent_28%),radial-gradient(circle_at_12%_82%,rgba(139,30,63,0.26),transparent_30%)]" />
                    <div className="absolute inset-0 -z-20 opacity-[0.055] [background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)] [background-size:72px_72px]" />
                    <div className="absolute right-[-150px] top-[80px] -z-10 h-[540px] w-[540px] rounded-full border border-white/10" />
                    <div className="absolute right-[-35px] top-[190px] -z-10 h-[320px] w-[320px] rounded-full border border-[#D5AD57]/20" />

                    <div className="mx-auto grid min-h-[560px] w-[min(1380px,calc(100%-48px))] items-center gap-16 pb-20 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_440px]">
                        <div>
                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                Awards
                            </div>

                            <h1 className="mt-7 max-w-[900px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(56px,7vw,104px)] font-normal leading-[0.92] tracking-[-0.05em]">
                                Awards that reflects
                                <span className="block text-[#D5AD57]">
                                    our academic journey.
                                </span>
                            </h1>
                        </div>

                        <div className="relative hidden min-h-[500px] lg:block">
                            <div className="absolute right-0 top-0 flex h-[410px] w-[340px] rotate-[3deg] items-center justify-center overflow-hidden rounded-[30px] border border-white/10 bg-white p-5 shadow-[0_30px_80px_rgba(0,0,0,0.3)]">
                                <img
                                    src={topAwards[1].image}
                                    alt="Dr. A.P.J. Abdul Kalam Inspiration Award for Best Private University in India"
                                    className="max-h-full max-w-full object-contain"
                                />
                            </div>

                            <div className="absolute bottom-0 left-0 flex h-[250px] w-[220px] -rotate-[5deg] items-center justify-center overflow-hidden rounded-[26px] border border-white/10 bg-white p-4 shadow-[0_20px_60px_rgba(0,0,0,0.28)]">
                                <img
                                    src={topAwards[0].image}
                                    alt="Best University in Central India for Placement 2023"
                                    className="max-h-full max-w-full object-contain"
                                />
                            </div>

                            <div className="absolute bottom-[28px] right-[-10px] rounded-[20px] border border-white/10 bg-[#8B1E3F] px-6 py-5 shadow-[0_15px_40px_rgba(0,0,0,0.2)]">
                                <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                    Awards
                                </span>
                                <strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal leading-none text-white">
                                    {awards.length}
                                </strong>
                            </div>
                        </div>
                    </div>

                    <div className="border-t border-white/10 bg-white/[0.035] backdrop-blur-md">
                        <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] sm:grid-cols-3">
                            <div className="py-6 sm:border-r sm:border-white/10 sm:px-8">
                                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                    Awards
                                </span>
                                <p className="mt-2 text-sm font-semibold text-white/80">
                                    Academic Excellence
                                </p>
                            </div>

                            <div className="py-6 sm:border-r sm:border-white/10 sm:px-8">
                                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                    Achievement
                                </span>
                                <p className="mt-2 text-sm font-semibold text-white/80">
                                    University Awards
                                </p>
                            </div>

                            <div className="py-6 sm:px-8">
                                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                    Journey
                                </span>
                                <p className="mt-2 text-sm font-semibold text-white/80">
                                    2017 to {new Date().getFullYear()}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* INTRO */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">
                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.75fr_1.25fr] lg:gap-20">
                        <div>
                            <Eyebrow>Awards & Achievement</Eyebrow>

                            <Title
                                before="A Journey Marked By"
                                highlight="Awards"
                                after=""
                                position="middle"
                                theme="burgundy"
                            />
                        </div>

                        <div className="lg:pt-8">
                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,2.9vw,42px)] font-normal leading-[1.35] text-[#071A2F]">
                                A collection of awards and recognitions received by ISBM
                                University across different years and areas of academic
                                achievement.
                            </p>

                            <div className="mt-10 flex items-center gap-5 border-t border-[#071A2F]/10 pt-7">
                                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[68px] font-normal leading-none text-[#8B1E3F]">
                                    {awards.length}
                                </strong>

                                <span className="text-xs font-bold uppercase leading-5 tracking-[0.14em] text-[#071A2F]/45">
                                    Awards &
                                    <br />
                                    Recognitions
                                </span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FEATURED AWARDS */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        <div className="border-b border-[#071A2F]/15 pb-10">
                            <Eyebrow>Featured Awards</Eyebrow>

                            <Title
                                before="Awards That"
                                highlight="Stand Out"
                                after=""
                                position="middle"
                                theme="burgundy"
                            />
                        </div>

                        <div className="mt-12 grid gap-6 lg:grid-cols-[1.2fr_.8fr]">
                            {/* MAIN FEATURED */}
                            <article className="group overflow-hidden rounded-[34px] border border-[#071A2F]/10 bg-white">
                                <div className="relative flex min-h-[620px] items-center justify-center bg-[#EEF4F8] p-8 sm:p-12">
                                    <img
                                        src={featuredAwards[0].image}
                                        alt={featuredAwards[0].title}
                                        className="max-w-full max-h-[660px] object-contain transition duration-500 group-hover:scale-[1.02]"
                                    />

                                    <div className="absolute left-6 top-6 rounded-full bg-[#071A2F] px-4 py-2">
                                        <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                                            Featured Award
                                        </span>
                                    </div>
                                </div>

                                <div className="bg-[#071A2F] p-7 text-white sm:p-9">
                                    <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
                                        <span className="text-xs font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                                            {featuredAwards[0].year}
                                        </span>

                                        {featuredAwards[0].year && (
                                            <span className="shrink-0 text-sm font-bold text-[#D5AD57]">
                                                {featuredAwards[0].category} - {featuredAwards[0].year}
                                            </span>
                                        )}
                                    </div>
                                    <h2 className="mt-3 max-w-[720px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,42px)] font-normal leading-[1.12] text-white">
                                        {featuredAwards[0].title}
                                    </h2>
                                </div>
                            </article>

                            {/* SECONDARY FEATURED */}
                            <div className="grid gap-6">
                                {featuredAwards.slice(1).map((award, index) => (
                                    <article
                                        key={award.year}
                                        className="group overflow-hidden rounded-[30px] border border-[#071A2F]/10 bg-white"
                                    >
                                        <div
                                            className={`flex max-h-[300px] items-center justify-center p-7 ${index === 0 ? "bg-[#F4E8EC]" : "bg-[#EEF4F8]"}`}
                                        >
                                            <img
                                                src={award.image}
                                                alt={award.title}
                                                className="max-h-[270px] max-w-full object-contain transition duration-500 group-hover:scale-[1.025]"
                                            />
                                        </div>

                                        <div className="border-t border-[#071A2F]/10 p-6">
                                            <div className="flex items-start justify-between gap-6">
                                                <span className="text-[10px] font-bold uppercase tracking-[0.13em] text-[#8B1E3F]">
                                                    {award.year}
                                                </span>

                                                {award.year && (
                                                    <span className="shrink-0 rounded-full bg-[#F7F2E8] px-3 py-2 text-xs font-bold text-[#8B1E3F]">
                                                        {award.category} - {award.year}
                                                    </span>
                                                )}
                                            </div>
                                            <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.15] text-[#071A2F]">
                                                {award.title}
                                            </h3>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* COMPLETE AWARDS */}
                <section className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28">
                    {/* BACKGROUND DETAIL */}
                    <div className="pointer-events-none absolute right-[-180px] top-[180px] h-[520px] w-[520px] rounded-full border border-[#071A2F]/[0.04]" />

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        {/* SECTION HEADER */}
                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-12 lg:grid-cols-[1fr_430px] lg:items-end">
                            <div>
                                <Eyebrow>Awards Archive</Eyebrow>

                                <Title
                                    before="Awards That"
                                    highlight="Marks Our Journey"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />
                            </div>

                            <div className="lg:pb-2">
                                <p className="text-[15px] leading-7 text-[#65727E]">
                                    Explore the awards and achievements that recognise ISBM
                                    University's contribution to education, innovation and
                                    institutional excellence.
                                </p>
                            </div>
                        </div>

                        {/* AWARDS */}
                        <div className="mt-16 space-y-10">
                            {awards.map((award, index) => (
                                <article
                                    key={award.year}
                                    className="group relative overflow-hidden rounded-[34px] border border-[#071A2F]/10 bg-[#F8F8F6]"
                                >
                                    <div
                                        className={`grid min-h-[520px] lg:grid-cols-2 ${index % 2 !== 0 ? "lg:[&>*:first-child]:order-2" : ""}`}
                                    >
                                        {/* AWARD IMAGE */}
                                        <div
                                            className={`relative flex min-h-[420px] items-center justify-center overflow-hidden p-7 sm:p-10 lg:min-h-[520px] lg:p-12 ${index % 4 === 0 ? "bg-[#F7F2E8]" : index % 4 === 1 ? "bg-[#EEF4F8]" : index % 4 === 2 ? "bg-[#F4E8EC]" : "bg-[#FDF7FC]"}`}
                                        >
                                            {/* LARGE NUMBER */}
                                            <span className="absolute left-7 top-5 font-['Libre_Caslon_Display',Georgia,serif] text-[70px] font-normal leading-none text-[#071A2F]/[0.05] sm:text-[90px]">
                                                {award.year}
                                            </span>

                                            {/* YEAR */}
                                            <div className="absolute right-6 top-6 z-10 rounded-full bg-[#071A2F] px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                                {award.year}
                                            </div>

                                            {/* IMAGE FRAME */}
                                            <div className="relative flex h-[340px] w-full items-center justify-center rounded-[24px] border border-[#071A2F]/10 bg-white p-5 shadow-[0_20px_60px_rgba(7,26,47,0.08)] sm:h-[400px] sm:p-7 lg:h-[430px]">
                                                <img
                                                    src={award.image}
                                                    alt={award.title}
                                                    className="h-[350px] w-full object-contain transition duration-700 group-hover:scale-[1.025]"
                                                />
                                            </div>
                                        </div>

                                        {/* AWARD CONTENT */}
                                        <div className="relative flex items-center bg-white p-8 sm:p-10 lg:p-14 xl:p-16">
                                            <div className="w-full">
                                                {/* CATEGORY */}
                                                <div className="flex items-center gap-4">
                                                    <span className="h-px w-10 bg-[#8B1E3F]" />

                                                    <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                        {award.category}
                                                    </span>
                                                </div>

                                                {/* TITLE */}
                                                <h3 className="mt-7 max-w-[550px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(34px,3.3vw,52px)] font-normal leading-[1.06] tracking-[-0.025em] text-[#071A2F]">
                                                    {award.title}
                                                </h3>

                                                {/* ORGANISATION */}
                                                <div className="mt-8 border-l-[3px] border-[#D5AD57] pl-5">
                                                    <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-[#132337]/40">
                                                        Presented / Recognised By
                                                    </span>

                                                    <strong className="mt-2 block text-[15px] font-bold text-[#071A2F]">
                                                        {award.organisation}
                                                    </strong>
                                                </div>

                                                {/* DESCRIPTION */}
                                                <p className="mt-8 max-w-[570px] text-[15px] leading-8 text-[#65727E]">
                                                    {award.description}
                                                </p>

                                                {/* FOOTER */}
                                                <div className="mt-10 flex items-center justify-between border-t border-[#071A2F]/10 pt-6">
                                                    <div>
                                                        <span className="block text-[9px] font-bold uppercase tracking-[0.15em] text-[#132337]/35">
                                                            Award Year
                                                        </span>

                                                        <span className="mt-1 block font-['Libre_Caslon_Display',Georgia,serif] text-[24px] text-[#8B1E3F]">
                                                            {award.year}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Award Gallery */}
                <section className="relative overflow-hidden bg-[#f7f2e8] py-16 sm:py-20 lg:py-24">
                    {/* Decorative background */}
                    <div className="pointer-events-none absolute -left-28 top-20 h-72 w-72 rounded-full bg-[#d5ad57]/10 blur-3xl" />
                    <div className="pointer-events-none absolute -right-24 bottom-10 h-80 w-80 rounded-full bg-[#8b1e3f]/10 blur-3xl" />

                    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        {/* Heading */}
                        <div className="mx-auto mb-10 max-w-3xl text-center sm:mb-14">
                            <div className="flex justify-center">
                                <Eyebrow dark>
                                    Moments of Recognition
                                </Eyebrow>
                            </div>

                            <div className="mt-4">
                                <Title
                                    before="Celebrating Excellence,"
                                    highlight="Honouring Achievement"
                                    position="end"
                                />
                            </div>

                            <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-[#526171] sm:text-base">
                                A glimpse into the milestones, honours and achievements
                                that reflect ISBM University's continuing commitment to
                                academic excellence, innovation and student success.
                            </p>
                        </div>

                        {/* Gallery */}
                        <div className="columns-1 gap-4 sm:columns-2 sm:gap-5 lg:columns-3 xl:columns-4">
                            {galleryImages.map((item, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    onClick={() => setSelectedImage(item)}
                                    className="group relative mb-4 block w-full break-inside-avoid overflow-hidden rounded-2xl bg-white text-left shadow-[0_10px_35px_rgba(7,26,47,0.08)] sm:mb-5"
                                >
                                    <img
                                        src={item.image}
                                        alt={item.alt}
                                        loading="lazy"
                                        className="h-auto w-full transition duration-700 ease-out group-hover:scale-[1.035]"
                                    />

                                    {/* Dark hover overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#071a2f]/95 via-[#071a2f]/20 to-transparent opacity-0 transition duration-500 group-hover:opacity-100" />

                                    {/* Gold line */}
                                    <div className="absolute bottom-0 left-0 h-1 w-0 bg-[#d5ad57] transition-all duration-500 group-hover:w-full" />

                                    {/* Content */}
                                    <div className="absolute inset-x-0 bottom-0 translate-y-5 p-5 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                                        <span className="mb-2 inline-block text-[10px] font-semibold uppercase tracking-[0.18em] text-[#e7c979]">
                                            {item.category}
                                        </span>

                                        <h3 className="max-w-[90%] text-base font-semibold leading-snug text-white">
                                            {item.title}
                                        </h3>

                                        <div className="mt-4 flex items-center gap-2 text-xs font-medium text-white/80">
                                            <span className="flex h-7 w-7 items-center justify-center rounded-full border border-white/30 bg-white/10">
                                                +
                                            </span>

                                            <span>View image</span>
                                        </div>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Lightbox */}
                {selectedImage && (
                    <div
                        className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#020b14]/95 p-4 backdrop-blur-md sm:p-8"
                        onClick={() => setSelectedImage(null)}
                    >
                        {/* Close */}
                        <button
                            type="button"
                            aria-label="Close gallery"
                            onClick={() => setSelectedImage(null)}
                            className="absolute right-4 top-4 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/10 text-2xl text-white transition hover:bg-white hover:text-[#071a2f] sm:right-8 sm:top-8"
                        >
                            ×
                        </button>

                        {/* Modal */}
                        <div
                            className="relative flex max-h-[92vh] w-full max-w-6xl flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#071a2f] shadow-2xl lg:flex-row"
                            onClick={(event) => event.stopPropagation()}
                        >
                            {/* Image */}
                            <div className="flex min-h-0 flex-1 items-center justify-center bg-black/30">
                                <img
                                    src={selectedImage.image}
                                    alt={selectedImage.alt}
                                    className="max-h-[72vh] w-full object-contain lg:max-h-[88vh]"
                                />
                            </div>

                            {/* Details */}
                            <div className="border-t border-white/10 p-5 lg:flex lg:w-[300px] lg:flex-col lg:justify-end lg:border-l lg:border-t-0 lg:p-7">
                                <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#d5ad57]">
                                    {selectedImage.category}
                                </span>

                                <h3 className="mt-2 text-xl font-semibold leading-snug text-white">
                                    {selectedImage.title}
                                </h3>

                                <p className="mt-3 text-sm leading-6 text-white/55">
                                    A memorable moment from ISBM University's journey
                                    of recognition and achievement.
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {/* TIMELINE */}
                <section className="relative overflow-hidden bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
                    {/* Decorative circles */}
                    <div className="absolute -right-24 top-0 h-[420px] w-[420px] rounded-full border border-white/[0.07]" />
                    <div className="absolute right-12 top-24 h-[250px] w-[250px] rounded-full border border-[#D5AD57]/20" />

                    <div className="relative mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.7fr_1.3fr] lg:gap-20">

                        {/* Heading */}
                        <div>
                            <Eyebrow dark>Awards Over Time</Eyebrow>

                            <Title
                                before="Awards Across"
                                highlight="The Years"
                                after=""
                                position="middle"
                                theme="gold"
                                dark
                            />

                            <p className="mt-5 max-w-md text-sm leading-7 text-white/65">
                                Explore the milestones and recognitions that have marked
                                ISBM University's journey over the years.
                            </p>
                        </div>

                        {/* Dynamic years */}
                        <div className="grid gap-px overflow-hidden border border-white/15 bg-white/15 sm:grid-cols-2 lg:grid-cols-4">
                            {awardsTimeline.map((item, index) => {
                                const isLatest = index === awardsTimeline.length - 1;

                                return (
                                    <div
                                        key={item.year}
                                        className={`group relative p-7 transition-all duration-300 ${isLatest
                                                ? "bg-[#8B1E3F]"
                                                : "bg-[#071A2F] hover:bg-[#7A1837]"
                                            }`}
                                    >
                                        {/* Year */}
                                        <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[46px] font-normal leading-none text-[#D5AD57]">
                                            {item.year}
                                        </strong>

                                        {/* Categories */}
                                        <p className="mt-2 line-clamp-2 text-xs leading-5 text-white/55">
                                            {item.categories.join(" • ")}
                                        </p>

                                        {/* Latest badge */}
                                        {isLatest && (
                                            <span className="mt-5 inline-flex rounded-full border border-[#D5AD57]/30 bg-[#D5AD57]/10 px-3 py-1 text-[9px] font-semibold uppercase tracking-[0.14em] text-[#D5AD57]">
                                                Latest
                                            </span>
                                        )}

                                        {/* Hover line */}
                                        <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#D5AD57] transition-all duration-300 group-hover:w-full" />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </>
    );
}
